import { Box, CardMedia, Stack } from "@mui/material";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import React from "react";
import AnimationCymplifyLogo from "./AnimationCymplifyLogo";

const CardCymplifyLogo = (props) => {
	
	return (
		<React.Fragment>
			<Box
				sx={{
					width: "16em",
					height: "16em",
					margin: "0.75em",
					borderRadius: "0.75em",
				}}
			>
				<Canvas sx={{ width: "100%", height: "100%" }}>
					<ambientLight />
					{/* <pointLight position={[10, 10, 10]} /> */}
					<AnimationCymplifyLogo/>
					<OrbitControls enableZoom={false} enablePan={false} rotateSpeed={0.2} />
				</Canvas>
				<CardMedia
					component='img'
					src={"/cymplify-logo-circle.png"}
					alt="company central logo"
					sx={{
						width: "6em",
						height: "6em",
						position: "relative",
						top: "-50%",
						left: "50%",
						transform: "translateX(-50%) translateY(-50%)",
						userSelect: "none",
						pointerEvents: "none"
					}}
				/>
			</Box>
		</React.Fragment>
	);

}

export default CardCymplifyLogo;